import React from "react";
import { useSelector } from "react-redux";

import "./ReportFooter.scss";

import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { ReactComponent as IdhLogo } from "src/images/idh-logo-color.svg";
import ProjectPlaceholder from "src/images/project-placeholder.svg";
import { getImageSource } from "src/utils/methods";
import { IDH_BRAND_COLOR } from "src/constants/idhBrandColor";

export function ReportFooter(props) {
  const { data } = props;

  const identity = useSelector((state) => state.mainReducer.identity);

  const customLogo =
    identity?.wsWorkspace?.smallLogo || identity?.wsWorkspace?.logo;

  const brandColor =
    identity?.wsWorkspace?.customPrimaryColor || IDH_BRAND_COLOR;

  return (
    <div className="report-footer">
      <div className="report-footer__campaign">
        <div className="report-footer__campaign-data">
          <img
            className="report-footer__campaign-data-logo"
            src={getImageSource(data?.cover, "small", ProjectPlaceholder)}
            alt="logo"
          />
          <span className="report-footer__campaign-data-title">
            {data.title}
          </span>
          <span className="report-footer__campaign-data-thank-you">
            <IDHFormattedMessage id="ws_thank_you" defaultMessage="Thank you" />
          </span>
        </div>
      </div>
      <div
        className="report-footer__indahash"
        style={{ backgroundColor: brandColor }}
      >
        <div className="report-footer__indahash-logo">
          <IDHFormattedMessage id="ws_powered_by" defaultMessage="Powered by" />

          <div className="report-footer__indahash-logo__img-container">
            {customLogo ? (
              <img
                src={customLogo}
                alt="logo"
                className="report-footer__indahash-logo__img"
              />
            ) : (
              <IdhLogo />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
